import { useTranslation } from 'react-i18next';

import { LoadingOverlay, Modal } from '@mantine/core';
import { Trash } from 'tabler-icons-react';

import { StyledButton } from '../shared';

import styles from './DeleteStorageModal.module.css';

type DeleteStorageModalProps = {
   canBeDeleted: boolean;
   onClose: () => void;
   onRemoveClick: () => void;
   opened: boolean;
   loading: boolean;
};

const DeleteStorageModal = ({
   canBeDeleted,
   onClose,
   opened,
   loading,
   onRemoveClick,
}: DeleteStorageModalProps) => {
   const { t } = useTranslation();

   const renderDescription = !canBeDeleted ? (
      <>
         <p className={styles.plainText}>{t('modals.deleteStorage.withPallets.message1')}</p>
         <p className={styles.plainText}>{t('modals.deleteStorage.withPallets.message2')}</p>
      </>
   ) : (
      <p className={styles.plainText}>{t('modals.deleteStorage.withoutPallets')}</p>
   );

   return (
      <Modal
         onClose={onClose}
         opened={opened}
         centered
         classNames={{
            modal: styles.modal,
         }}
      >
         <>
            <div className={styles.modalContent}>
               <Trash
                  size={48}
                  strokeWidth={1.5}
                  color={'var(--primary-red)'}
                  style={{ marginBottom: 26 }}
               />
               <h3>{t('storage.deleteWarehouse')}</h3>
               <div className={styles.descriptionContainer}>
                  {renderDescription}
                  <p className={styles.boldBlackText}>{t('cancel_pallet_report_modal.irreversible')}</p>
               </div>
               <LoadingOverlay
                  visible={loading}
                  overlayBlur={10}
                  loaderProps={{ color: 'var(--light-green)' }}
               />
            </div>
            <div className={styles.btnsContainer}>
               <StyledButton
                  text={t('modals.deleteStorage.cancel')}
                  onClick={onClose}
                  variant="outlined-danger"
               />
               <StyledButton
                  type="button"
                  text={
                     canBeDeleted
                        ? t('storage.deleteWarehouse')
                        : t('modals.deleteStorage.deleteWithPallets')
                  }
                  onClick={onRemoveClick}
                  variant="filled-danger"
                  disabled={loading}
               />
            </div>
         </>
      </Modal>
   );
};

export default DeleteStorageModal;
